import FatReducedMilkProduct from 'models/FatReducedMilkProduct'

export const fatReducedMilkTypeOptions = [
  {
    value: '',
    label: 'Fat Reduced Milk Type',
    isDisabled: true,
  },
  {
    value: 'Nonfat',
    label: 'Nonfat',
    subCategory: '002',
  },
  { value: '1% Lowfat', label: '1% Lowfat', subCategory: '002' },
  { value: '2% Reduced Fat', label: '2% Reduced Fat', subCategory: '004' },
  {
    value: '2% Reduced Fat Lactose Free',
    label: '2% Reduced Fat Lactose Free',
    subCategory: '006',
  },
  {
    value: 'Nonfat Lactose Free',
    label: 'Nonfat Lactose Free',
    subCategory: '006',
  },
  {
    value: 'Lowfat Lactose Free',
    label: 'Lowfat Lactose Free',
    subCategory: '006',
  },
  {
    value: 'Nonfat Powdered Dry',
    label: 'Nonfat Powdered Dry',
    subCategory: '012',
  },
  {
    value: 'Nonfat Evaporated',
    label: 'Nonfat Evaporated',
    subCategory: '014',
  },
]

export const containerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
  { value: 'One Gallon', label: 'One Gallon' },
  { value: '12 oz Can', label: '12 oz Can' },
  { value: '9.6 oz Powdered', label: '9.6 oz Powdered' },
  { value: '25.6 oz Powdered', label: '25.6 oz Powdered' },
]

export const containerSizeOptionsDefault = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
]

export const fatContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
  { value: 'One Gallon', label: 'One Gallon' },
]

export const lactoseContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: 'Half Gallon',
    label: 'Half Gallon',
  },
  {
    value: '.75 Gallon',
    label: '.75 Gallon',
  },
  {
    value: 'One Gallon',
    label: 'One Gallon',
  },
]

export const powderedContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '9.6 oz Powdered', label: '9.6 oz Powdered' },
  { value: '25.6 oz Powdered', label: '25.6 oz Powdered' },
]

export const evaporatedContainerSizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  { value: '12 oz Can', label: '12 oz Can' },
]

export const packagingInitialState = {
  category: FatReducedMilkProduct.category,
  subCategory: FatReducedMilkProduct.subCategory,
  ReducedFatMilkType: {
    value: fatReducedMilkTypeOptions[0].value,
    label: fatReducedMilkTypeOptions[0].label,
  },
  ReducedFatMilkSize: {
    value: containerSizeOptions[0].value,
    label: containerSizeOptions[0].label,
  },
}
